import { LanguageCodeEnum } from '@/graphql';
import { useLocale } from 'next-intl';

export const useLanguageCode = () => {
  const locale = useLocale();
  return locale === 'uz' ? LanguageCodeEnum.UZ : LanguageCodeEnum.RU;
};
